/**
 * Anchor re-measure bus (#1220 item 1).
 *
 * The pro bar's two portal-anchored surfaces — the desktop popovers
 * (useSbpPopover) and the body-portaled Where listbox (ProWhereField) — track
 * the bar's viewport rect on scroll/resize. A sticky pin or unpin (and the
 * compress/expand morph) moves the bar AFTER the scroll event that triggered
 * it has already run those measurements, so an open surface held stale
 * coordinates until the next scroll pixel — persistent when the visitor
 * stopped scrolling exactly at the crossing. ProFilterBar publishes once the
 * sticky DOM has committed; open surfaces re-measure on that signal.
 *
 * Module-scoped on purpose: a re-measure is idempotent and cheap, so one bus
 * across widget instances beats threading a context through three dialogs
 * for the rare multi-explorer page.
 */
type Listener = () => void

const listeners = new Set<Listener>()

/** Subscribe an open surface's re-measure; returns the unsubscribe. */
export function subscribeSbpAnchor(fn: Listener): () => void {
  listeners.add(fn)
  return () => {
    listeners.delete(fn)
  }
}

/** Ask every open anchored surface to re-measure now. */
export function remeasureSbpAnchors(): void {
  for (const fn of Array.from(listeners)) fn()
}
